import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 5em 0;

    .offer-boxes {
        padding: 3em 0;
    }

    .offer-boxes-mobile {

        padding: 3em 0;
    }

    @media all and (max-width: ${variables.mobileL}) {

    }

    @media all and (max-width: ${variables.mobileL}) {
        padding: 5em 0;
        background-color: #F3F3F3;


    }
`;